import {
  ArrowsRightLeftIcon,
  Button,
  ChevronLeftIcon,
  Dialog,
  Drawer,
  Flex,
  LoaderCover,
  QrCodeIcon,
  Text,
} from 'components'
import { isEmpty } from 'lodash-es'
import { lazy, Suspense, useState } from 'react'
import { PrimaryLeadProperties, primaryLeadProperties, QRCodeConfiguration } from 'types'
import { useDisclosure } from 'utils'
import { useEventInfo } from '../../../pages/EventInfoPage'
import PropertyMapper, { defaultPrimaryProperties } from '../../PropertyMapper'

const QrScanner = lazy(() => import('./QrScanner'))

interface Props {
  qrCode: QRCodeConfiguration
  onUpdate?: (qrCode: QRCodeConfiguration) => void
}

export default function QrMappingDrawer({ qrCode, onUpdate }: Props) {
  const { showFieldMapping, updateShowFieldMapping } = useEventInfo()
  const [qrFields, setQrFields] = useState<Record<string, string>>()
  const [leadMapping, setLeadMapping] = useState<PrimaryLeadProperties>()
  const { open: dialogIsOpen, onOpen: dialogOnOpen, onClose: dialogOnClose } = useDisclosure()

  async function finishMapping() {
    if (!leadMapping) return

    onUpdate?.({ ...qrCode, leadMapping })
    updateShowFieldMapping(false)
  }

  return (
    <>
      <Drawer
        onClose={() => updateShowFieldMapping(false)}
        size="lg"
        open={showFieldMapping}
        header={
          <Button
            variant="link"
            leftIcon={<ChevronLeftIcon />}
            onClick={() => updateShowFieldMapping(false)}
            px={0}
          >
            Back
          </Button>
        }
        footer={
          <Button palette="primary" disabled={isEmpty(leadMapping)} onClick={finishMapping}>
            Done
          </Button>
        }
      >
        {qrFields ? (
          <Flex direction="column" gap={3}>
            <Flex justify="space-between" px={5}>
              <Flex gap={2} align="center" p={2}>
                <ArrowsRightLeftIcon fontSize="lg" />
                <Text textStyle="h6">Map Fields</Text>
              </Flex>
              <Button variant="outline" leftIcon={<QrCodeIcon />} onClick={dialogOnOpen}>
                Re-Scan Test QR Code
              </Button>
            </Flex>
            <PropertyMapper
              defaultProperties={defaultPrimaryProperties}
              inputFieldLabel="QR Code Fields"
              inputMap={qrFields}
              onChange={setLeadMapping}
              properties={primaryLeadProperties}
            />
          </Flex>
        ) : (
          <Suspense fallback={<LoaderCover show={true} />}>
            <QrScanner qrCode={qrCode} onRead={setQrFields} />
          </Suspense>
        )}
      </Drawer>

      <Dialog
        open={dialogIsOpen}
        onClose={dialogOnClose}
        size="xl"
        placement="center"
        bodyProps={{ display: 'flex', p: 6 }}
      >
        <QrScanner
          qrCode={qrCode}
          onRead={value => {
            setQrFields(value)
            dialogOnClose()
          }}
        />
      </Dialog>
    </>
  )
}
